// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/GroupStageChip.tsx
import { FunctionComponent } from 'react';
import { Flex, Input } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { SeasonFormData } from '../../schemas';
import { QualifierZonesInputs } from './QualifierZonesInputs';

type GroupStageChipProps = {
  index: number;
  /** Esconde a seção de exemplos abaixo dos inputs (uma instância já mostra). */
  hideCheatSheet?: boolean;
};

/** Chip de fase de grupo com o nome editável inline + cutoffs de qualifier zones. */
export const GroupStageChip: FunctionComponent<GroupStageChipProps> = ({
  index,
  hideCheatSheet = false,
}) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const hasNameError = !!errors.group_stages?.[index]?.group_name;
  const groupErrors = errors.group_stages?.[index];
  const hasQualifiersError =
    !!groupErrors?.direct_qualifiers_count ||
    !!groupErrors?.playoff_qualifiers_count ||
    !!groupErrors?.secondary_qualifiers_count ||
    !!groupErrors?.relegated_count;

  return (
    <Flex
      direction="column"
      gap={2}
      bg="purple.50"
      borderWidth="1px"
      borderColor={hasNameError || hasQualifiersError ? 'red.400' : 'purple.100'}
      borderRadius="md"
      px={3}
      py={2}
    >
      <Flex align="center" gap={1.5}>
        <ChakraFeatherIcon name="grid" boxSize="14px" color="brand.500" />
        <Input
          variant="unstyled"
          size="sm"
          w="110px"
          fontWeight="medium"
          color="brand.700"
          {...register(`group_stages.${index}.group_name`)}
        />
      </Flex>
      <QualifierZonesInputs
        directName={`group_stages.${index}.direct_qualifiers_count`}
        playoffName={`group_stages.${index}.playoff_qualifiers_count`}
        secondaryName={`group_stages.${index}.secondary_qualifiers_count`}
        relegatedName={`group_stages.${index}.relegated_count`}
        directLabelName={`group_stages.${index}.direct_qualifiers_label`}
        playoffLabelName={`group_stages.${index}.playoff_qualifiers_label`}
        secondaryLabelName={`group_stages.${index}.secondary_qualifiers_label`}
        relegatedLabelName={`group_stages.${index}.relegated_qualifiers_label`}
        hideCheatSheet={hideCheatSheet}
        errorMessage={
          hasQualifiersError
            ? t('pages.application_season.components.season_step2.schema.qualifiers_overflow')
            : undefined
        }
      />
    </Flex>
  );
};
